export default {
  pending: "pending",
  active: "active",
  exiting: "exiting",
  history: "history"
};
